import { render, staticRenderFns } from "./TSGalleryWidget.vue?vue&type=template&id=0bdafb7b&scoped=true&"
import script from "./TSGalleryWidget.vue?vue&type=script&lang=js&"
export * from "./TSGalleryWidget.vue?vue&type=script&lang=js&"
import style0 from "./TSGalleryWidget.vue?vue&type=style&index=0&id=0bdafb7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdafb7b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VImg,VProgressCircular,VRow})
